interface Props {
  className?: string;
  /** Altura en píxeles. El ancho se ajusta automáticamente por el viewBox. */
  altura?: number;
}

/**
 * Logo oficial de Adelante (W estilizada).
 *
 * SVG vectorial: escala sin pérdida en cualquier tamaño. Dos paths:
 *   - Verde principal #ADD010 (los 2 brazos exteriores de la W).
 *   - Verde sombra #88A024 (los 2 brazos interiores).
 *
 * Ratio del viewBox 745 × 326 ≈ 2.28:1 → con altura 20px el ancho real
 * queda ~45px. Si necesitás un tamaño distinto pasá `altura`.
 */
export function LogoAdelante({ className, altura = 20 }: Props) {
  return (
    <svg
      role="img"
      aria-label="Logo Adelante"
      className={className}
      height={altura}
      viewBox="0 0 745 326"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M541.795 94.8125H331.851L189.631 325.073H402.984L541.795 94.8125ZM744.966 209.943H535.022L467.299 325.073H677.242L744.966 209.943Z"
        fill="#88A024"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H208.863L402.138 325.074H189.626L0 0ZM331.846 94.8132H541.79L677.237 325.074H467.907L331.846 94.8132Z"
        fill="#ADD010"
      />
    </svg>
  );
}
